// Every category a filed bug may carry, most important first. Keep this module dependency-free so the
// client, server, and eval input contracts can all derive their narrower schemas from one source.
export const BUG_CATEGORIES = [
  'testing',
  'network-performance',
  'react-rendering',
  'layout-shift',
  'glitches',
  'user-experience',
  'accessibility',
  'ui-details',
  'seo',
  'security',
] as const

export type BugCategory = (typeof BUG_CATEGORIES)[number]
